<template>
  <header class="d-flex flex-row flex-wrap justify-content-between">
    <section class="w-70 d-flex flex-row justify-content-between">
      <a target="_blank" href="http://www.fcrobi.com" title="FC Robi Website">
        <img class="img-fluid" alt="" title="" src="../../assets/img/logo-1.png">
      </a>
      <div class="align-self-center">
        <a target="_blank" href="http://www.fcrobi.com" title="FC Robi Website">
          <font-awesome-icon :icon="['fas', 'home']"></font-awesome-icon>
          <span>FC ROBI</span>
        </a>
      </div>
<!--
      <div>
        <font-awesome-icon :icon="['fas', 'comment-alt']"></font-awesome-icon>
        <span>8</span>
      </div>
      <div>
        <font-awesome-icon :icon="['fas', 'envelope']"></font-awesome-icon>
        <span>12</span>
      </div>
-->
      <div class="align-self-center">
        <font-awesome-icon :icon="['fas', 'plus']"></font-awesome-icon>
        <span>Créer</span>
        <ul>
          <li v-b-modal="'modal-ajouter-' + menu.titre"
              v-if="menu.titre !== 'admin'"
              :key="menu.id + idx"
              v-for="(menu, idx) in getMenu">
            <font-awesome-icon :icon="menu.icon"></font-awesome-icon>
            <span>{{menu.titre}}</span>
          </li>
        </ul>
      </div>
    </section>
    <section class="align-self-center">
      <span>Bonjour, Roger</span>
      <font-awesome-icon class="cursor-pointer" @click="logout" :icon="['fas', 'power-off']"></font-awesome-icon>
    </section>
    <!-- Debut modal ajouter arbitres -->
    <b-modal header-class=""
             header-bg-variant="dark"
             header-text-variant="white"
             hide-footer
             title="Ajouter les arbitres"
             id="modal-ajouter-arbitres"
             @close="reloadPage"
             centered>
      <app-create-arbitres></app-create-arbitres>
    </b-modal>
    <!-- Fin modal ajouter arbitres -->

    <!-- Debut modal ajouter articles -->
    <b-modal header-class=""
             header-bg-variant="dark"
             header-text-variant="white"
             hide-footer
             title="Ajouter les articles"
             id="modal-ajouter-articles"
             @close="reloadPage"
             centered>
      <app-create-articles></app-create-articles>
    </b-modal>
    <!-- Fin modal ajouter articles -->

    <!-- Debut modal ajouter buteurs -->
    <b-modal header-class=""
             header-bg-variant="dark"
             header-text-variant="white"
             hide-footer
             title="Ajouter les buteurs"
             id="modal-ajouter-buteurs"
             @close="reloadPage"
             centered>
      <app-create-buteurs></app-create-buteurs>
    </b-modal>
    <!-- Fin modal ajouter buteurs -->

    <!-- Debut modal ajouter cartons -->
    <b-modal header-class=""
             header-bg-variant="dark"
             header-text-variant="white"
             hide-footer
             title="Ajouter les cartons"
             id="modal-ajouter-cartons"
             @close="reloadPage"
             centered>
      <app-create-cartons></app-create-cartons>
    </b-modal>
    <!-- Fin modal ajouter cartons -->

    <!-- Debut modal ajouter championnats -->
    <b-modal header-class=""
             header-bg-variant="dark"
             header-text-variant="white"
             hide-footer
             title="Ajouter les championnats"
             id="modal-ajouter-championnats"
             @close="reloadPage"
             centered>
      <app-create-championnats></app-create-championnats>
    </b-modal>
    <!-- Fin modal ajouter championnats -->

    <!-- Debut modal ajouter classements -->
    <b-modal id="modal-ajouter-classements"
             header-class=""
             header-bg-variant="dark"
             header-text-variant="white"
             hide-footer
             title="Ajouter les classements"
             @close="reloadPage"
             centered>
      <app-create-classements></app-create-classements>
    </b-modal>
    <!-- Fin modal ajouter classements -->

    <!-- Debut modal ajouter equipes -->
    <b-modal id="modal-ajouter-equipes"
             header-class=""
             header-bg-variant="dark"
             header-text-variant="white"
             hide-footer
             title="Ajouter les equipes"
             @close="reloadPage"
             centered>
      <app-create-equipes></app-create-equipes>
    </b-modal>
    <!-- Fin modal ajouter equipes -->

    <!-- Debut modal ajouter joueurs -->
    <b-modal id="modal-ajouter-joueurs"
             header-class=""
             header-bg-variant="dark"
             header-text-variant="white"
             hide-footer
             title="Ajouter les joueurs"
             @close="reloadPage"
             centered>
      <app-create-joueurs></app-create-joueurs>
    </b-modal>
    <!-- Fin modal ajouter joueurs -->

    <!-- Debut modal ajouter matchs -->
    <b-modal id="modal-ajouter-matchs"
             header-class=""
             header-bg-variant="dark"
             header-text-variant="white"
             hide-footer
             title="Ajouter les matchs"
             @close="reloadPage"
             centered>
      <app-create-matchs></app-create-matchs>
    </b-modal>
    <!-- Fin modal ajouter matchs -->

    <!-- Debut modal ajouter messages -->
    <b-modal id="modal-ajouter-messages"
             header-class=""
             header-bg-variant="dark"
             header-text-variant="white"
             hide-footer
             title="Ajouter les messages"
             @close="reloadPage"
             centered>
      <app-create-messages></app-create-messages>
    </b-modal>
    <!-- Fin modal ajouter messages -->

    <!-- Debut modal ajouter resultats -->
    <b-modal id="modal-ajouter-resultats"
             header-class=""
             header-bg-variant="dark"
             header-text-variant="white"
             hide-footer
             title="Ajouter les résultats"
             @close="reloadPage"
             centered>
      <app-create-resultats></app-create-resultats>
    </b-modal>
    <!-- Fin modal ajouter resultats -->

    <!-- Debut modal ajouter saisons -->
    <b-modal id="modal-ajouter-saisons"
             header-class=""
             header-bg-variant="dark"
             header-text-variant="white"
             hide-footer
             title="Ajouter les saisons"
             @close="reloadPage"
             centered>
      <app-create-saisons></app-create-saisons>
    </b-modal>
    <!-- Fin modal ajouter saisons -->

    <!-- Debut modal ajouter staffs -->
    <b-modal id="modal-ajouter-staffs"
             header-class=""
             header-bg-variant="dark"
             header-text-variant="white"
             hide-footer
             title="Ajouter les staffs"
             @close="reloadPage"
             centered>
      <app-create-staffs></app-create-staffs>
    </b-modal>
    <!-- Fin modal ajouter staffs -->

    <!-- Debut modal ajouter terrains -->
    <b-modal id="modal-ajouter-terrains"
             header-class=""
             header-bg-variant="dark"
             header-text-variant="white"
             hide-footer
             title="Ajouter les terrains"
             @close="reloadPage"
             centered>
      <app-create-terrains></app-create-terrains>
    </b-modal>
    <!-- Fin modal ajouter terrains -->
  </header>
</template>

<script>
import CreateAdmin from "../admin/components/Create";
import CreateArbitres from "../arbitres/components/Create";
import CreateArticles from "../articles/components/Create";
import CreateButeurs from "../buteurs/components/Create";
import CreateCartons from "../cartons/components/Create";
import CreateChampionnats from "../championnats/components/Create";
import CreateClassements from "../classements/components/Create";
import CreateEquipes from "../equipes/components/Create";
import CreateJoueurs from "../joueurs/components/Create";
import CreateMatchs from "../matchs/components/Create";
import CreateMessages from "../messages/components/Create";
import CreateResultats from "../resultats/components/Create";
import CreateSaisons from "../saisons/components/Create";
import CreateStaffs from "../staffs/components/Create";
import CreateTerrains from "../terrains/components/Create";
import {mapGetters, mapMutations, mapActions} from "vuex"

export default {
  name: "Header",
  components: {
    AppCreateAdmin: CreateAdmin,
    AppCreateArbitres: CreateArbitres,
    AppCreateArticles: CreateArticles,
    AppCreateButeurs: CreateButeurs,
    AppCreateCartons: CreateCartons,
    AppCreateChampionnats: CreateChampionnats,
    AppCreateClassements: CreateClassements,
    AppCreateEquipes: CreateEquipes,
    AppCreateJoueurs: CreateJoueurs,
    AppCreateMatchs: CreateMatchs,
    AppCreateMessages: CreateMessages,
    AppCreateResultats: CreateResultats,
    AppCreateSaisons: CreateSaisons,
    AppCreateStaffs: CreateStaffs,
    AppCreateTerrains: CreateTerrains,
  },
  data(){
    return{
      dataForm: {
      }
    }
  },
  methods: {
    ...mapMutations([]),
    ...mapActions([
        'sign_out'
    ]),
    reloadPage(){
      location.reload(false)
    },
    logout() {
      sessionStorage.removeItem('token')
      this.sign_out()
    }
  },
  computed: {
    ...mapGetters([
        'getMenu'
    ])
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>
.modalHeader{
  background-color: #cccc00 !important;
  font-size: x-large;
  width: 100%;
  margin: 0;
  padding: 0;
}
header{
  background: radial-gradient(circle, var(--color-light-golden-orange, rgba(204, 204, 0, .5)), var(--color-golden-orange, rgba(204, 204, 0, 1)));
  color: var(--color-white, rgba(255, 255, 255, 1));
  font-size: large;
  & > section:first-child{
    & > a{
      & > img{
        margin-left: 1rem;
        width: 30px;
      }
    }
    & > div{
      padding: .9rem .5rem;
      & > a{
        color: var(--color-white, rgba(255, 255, 255, 1));
        font-weight: lighter;
      }
      & > a:hover{
        color: var(--color-black, rgba(0, 0, 0, 1));
        font-weight: lighter;
        text-decoration: none;
      }
    }
    & > div:last-child{
      & > ul{
        z-index: 3;
        display: none;
        margin-top: 4px;
        margin-left: -8px;
        position: absolute;
        list-style: none;
        padding-left: 0;
        //background: var(--color-light-golden-orange, rgba(204, 204, 0, .5));
        background: radial-gradient(circle, var(--color-light-golden-orange, rgba(204, 204, 0, .5)), var(--color-golden-orange, rgba(204, 204, 0, 1)));
        color: var(--color-white, rgba(255, 255, 255, 1));
        width: 220px;
        & > li{
          font-size: medium;
          padding: .25rem .5rem;
          border-bottom: 1px dashed var(--color-white, rgba(255, 255, 255, 1));
          & > svg{
            width: 13%;
          }
        }
        & > li:hover{
          background-color: var(--color-white, rgba(255, 255, 255, 1));
          color: var(--color-black, rgba(0, 0, 0, 1));
          border: 1px dashed var(--color-black, rgba(0, 0, 0, 1));
        }
      }
    }
    & > div:last-child:hover{
      & > ul{
        display: block;
      }
    }
    & > div:hover{
      background-color: var(--color-white, rgba(255, 255, 255, 1));
      color: var(--color-black, rgba(0, 0, 0, 1));
      cursor: pointer;
    }
  }
  & > section:last-child{
    font-weight: lighter;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Header.vue